//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Domains from './components/Domains.vue'

export default {
  name: 'LayoutDefault',

  components: {
    Domains
  },

  data () {
    return {
      leftDrawerOpen: false
    }
  }
}
